<div [ngClass]="{'parent': is_parent}"
     class="menu-item">
	<div class="inner">
		<div class="item-label">
			<span class="item-label__text">{{ submenuItem.label }}</span>
			<sup *ngIf="submenuItem.is_beta" class="badge-beta">BETA</sup>
		</div>
		<div *ngIf="is_parent"
		     class="icon-keyboard_backspace--180">
		</div>
	</div>
</div>
